import { render, staticRenderFns } from "./ChannelCulture.vue?vue&type=template&id=231c8cb4"
import script from "./ChannelCulture.vue?vue&type=script&lang=js"
export * from "./ChannelCulture.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ChannelCulture.vue?vue&type=style&index=1&id=231c8cb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports